import Alpine from 'alpinejs';
document.addEventListener("alpine:init", () => {

    Alpine.data('hashtagSearch', (query) => ({
        query: query,
        searchedHashtag: {},
        categories: {},
        selectedHashtags: [],
        selectedCategory: null,
        showModal: false,
        newCollectionName: "",
        isAddingCollection: false,
        isAddingHashtags: false,
        collectionName: "",
        showAddedHashtagsSuccess: false,
        showing: "hashtags",
        isLoading: false,
        hasError: false,
        errorMessage: "",
        retryStatusInterval: null,
        onlyContainingWord: false,
        filterAverageLikes: false,
        minimumLikes: 0,
        maximumLikes: 100000,
        filterCharacterLimit: false,
        characterLimitMaximum: 30,
        showUnanalyzedHashtags: true,
        showEasiestHashtags: true,
        showEasyHashtags: true,
        showNormalHashtags: true,
        showHardHashtags: true,
        showBannedHashtags: true,
            
        init() {
            if (this.query !== "") {
                this.performSearch();
            }
        },

        async performSearch() {
            this.isLoading = true;

            try {
                const payload = {
                    query: this.query,
                    only_containing_word: this.onlyContainingWord,
                };
                const response = await fetch(`/search_hashtags/perform_search`, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) throw new Error("Failed to perform search");

                const data = await response.json();
                if( data.success ) {
                    this.searchedHashtag.id = data.master_hashtag_id;
                    this.startMasterHashtagStatusRefresh();
                } else{
                    this.searchedHashtag = {};
                    if (this.retryStatusInterval) {
                        clearInterval(this.retryStatusInterval);
                    }
                }
            } catch (error) {
                this.hasError = true;
                this.errorMessage = error.message;
            }
        },

        async startMasterHashtagStatusRefresh() {
            if (this.retryStatusInterval) {
                clearInterval(this.retryStatusInterval);
            }
            this.retryStatusInterval = setInterval(() => {
                fetch(`/master_hashtags/${this.searchedHashtag.id}/refresh_status`, {
                    method: "GET",
                    headers: {
                        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.status === "success") {
                        this.searchedHashtag.status = data.status;
                        this.getResults();
                        clearInterval(this.retryStatusInterval);
                    } else {
                        this.searchedHashtag.status = data.status;
                        if ( data.status === "unauthorized" || data.status === "failure" ) {
                            clearInterval(this.retryStatusInterval);
                            this.isLoading = false;
                        }
                    }
                })
                .catch(error => {
                    console.error("Error checking status:", error);
                });
            }, 2000);
        },

        async getResults() {
            this.isLoading = true;
            try {
                const payload = {
                    only_containing_word: this.onlyContainingWord,
                    filter_average_likes: this.filterAverageLikes,
                    minimum_likes: this.minimumLikes,
                    maximum_likes: this.maximumLikes,
                    filter_character_limit: this.filterCharacterLimit,
                    character_limit_maximum: this.characterLimitMaximum,
                    show_unanalyzed_hashtags: this.showUnanalyzedHashtags,
                    show_easiest_hashtags: this.showEasiestHashtags,
                    show_easy_hashtags: this.showEasyHashtags,
                    show_normal_hashtags: this.showNormalHashtags,
                    show_hard_hashtags: this.showHardHashtags,
                    show_banned_hashtags: this.showBannedHashtags
                };

                const response = await fetch(`/master_hashtags/${this.searchedHashtag.id}/get_results`, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) throw new Error("Failed to fetch account data.");

                const data = await response.json();
                this.searchedHashtag = data.master_hashtag;
                this.categories = data.categories;

                if ( this.searchedHashtag.status === "pending" ) {
                    this.startMasterHashtagStatusRefresh();
                } 

                this.hasError = false;
            } catch (error) {
                this.hasError = true;
                this.errorMessage = error.message;
            } finally {
                this.isLoading = false;
            }
        },

        toggleSection(section) {
            this.showing = section;
        },

        toggleHashtagSelection(hashtagId) {
            if (this.selectedHashtags.includes(hashtagId)) {
                this.selectedHashtags = this.selectedHashtags.filter(id => id !== hashtagId);
            } else {
                this.selectedHashtags.push(hashtagId);
            }
        },
    
        toggleSelectAllHashtags() {
            if (this.selectedHashtags.length === this.competitor.competitor_hashtags.length) {
                // If all contacts are selected, clear selection
                this.selectedHashtags = [];
            } else {
                // Otherwise, select all
                let hashtag_ids = this.competitor.competitor_hashtags.map(hashtag => hashtag.id);
                this.selectedHashtags = hashtag_ids;
            }
        },

        checkSelectedCategory() {
            if (this.selectedCategory == 0) {
                this.showModal = true; // Open modal when "Create New Collection" is selected
                this.modalMode = "category";
                this.newCollectionName = ""; // Reset input
                this.selectedCategory = null; // Reset selection to prevent accidental submissions
                this.$nextTick(() => document.querySelector("#newCollectionName").focus()); // Focus on input
            }
        },

        async addHashtagsToCollection() {
            if (!this.selectedCategory) {
                alert("Please select a collection.");
                return;
            }

            this.isAddingHashtags = true;
            try {
                const response = await fetch('/hashtags/add_to_collection', {
                    method: 'POST',
                    headers: {
                        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content"),
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        category: this.selectedCategory,
                        hashtags: this.selectedHashtags,
                        source: "search"
                    })
                });

                this.collectionName = this.categories.find(category => category.id == this.selectedCategory).name;
                if (!response.ok) throw new Error("Failed to add hashtags.");
                this.showAddedHashtagsSuccess = true;
                this.selectedHashtags = [];
            } catch (error) {
                console.error(error);
                alert("Failed to add hashtags.");
            } finally {
                this.isAddingHashtags = false;
                setTimeout(() => this.showAddedHashtagsSuccess = false, 4000);
            }
        },

        async createNewCollection() {
            if (!this.newCollectionName.trim()) {
                alert("Please enter a collection name.");
                return;
            }

            this.isAddingCollection = true;
            try {
                const response = await fetch('/collections/new_ajax', {
                    method: 'POST',
                    headers: {
                        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content"),
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ 
                        name: this.newCollectionName
                    })
                });

                if (!response.ok) throw new Error("Failed to create collection.");

                const newCategory = await response.json();
                this.categories.push(newCategory);
                this.categories.sort((a, b) => a.name.localeCompare(b.name));
                this.selectedCategory = newCategory.id;
                this.newCollectionName = "";
                this.isAddingCollection = false;
                this.showModal = false;
            } catch (error) {
                console.error(error);
                alert("Failed to create collection.");
            } finally {
                this.isAddingCollection = false;
            }
        },

        searchButtonText() {
            return this.isLoading ? "Searching..." : "Search";
        }
    }));
});